import { useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { useReportIssueWidget } from '@/contexts/ReportIssueWidgetContext'
import { SystemIssuesLayout } from './layout/SystemIssuesLayout'

const PROCESS_ROUTE_PATTERN = /^\/processo\/(\d+)/

/**
 * Entry point global — montado em `App.tsx` como irmão de `<AppRouter/>`
 * (fora dele, dentro de `<Router>`), então renderiza em QUALQUER página
 * autenticada. O gatilho é o item "Relatar um problema" no rodapé da
 * `Sidebar` (via `useReportIssueWidget().openWidget()`) — este componente só
 * cuida de renderizar o drawer em si quando `isOpen` (context compartilhado).
 *
 * Abre um painel lateral (drawer) de largura fixa — precisa de espaço real
 * pra lista de mensagens + composer + anexos.
 */
export function ReportIssueWidget() {
  const { user, isAuthenticated, isLoading } = useAuth()
  const location = useLocation()
  const { isOpen, closeWidget } = useReportIssueWidget()

  const hideOnRoute =
    location.pathname === '/login' ||
    location.pathname === '/first-access' ||
    location.pathname === '/forgot-password' ||
    location.pathname.startsWith('/auth/') ||
    // Já está na página dedicada — abrir o widget por cima seria redundante.
    location.pathname.startsWith('/system-issues')

  const relatedProcessMatch = location.pathname.match(PROCESS_ROUTE_PATTERN)
  const relatedProcessId = relatedProcessMatch
    ? Number(relatedProcessMatch[1])
    : null

  if (isLoading || !isAuthenticated || !user || hideOnRoute || !isOpen) {
    return null
  }

  return (
    <>
      <div
        role="presentation"
        aria-hidden
        onClick={closeWidget}
        className="fixed inset-0 z-[9997] bg-black/20"
      />
      <div
        className="fixed inset-y-0 right-0 z-[9998] flex w-[min(100vw,28rem)] flex-col border-l border-border-subtle bg-surface shadow-2xl"
        role="dialog"
        aria-label="Reportar Problema"
      >
        <SystemIssuesLayout
          variant="widget"
          relatedProcessId={relatedProcessId}
          onClose={closeWidget}
        />
      </div>
    </>
  )
}
